export default __webpack_public_path__ + "static/media/mobileMenuGraphic.06fb9378.svg";